import React, { useState } from 'react';
import { Card, Button } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import UpdateVouchersForm from './forms/UpdateVouchersForm';
import DeleteVoucherForm from './forms/DeleteVouchersForm';
const BuyOptionList = ({ item, extractData, propertyId, isBuyOption, voucherId, currency }) => {
  const [isshowDelete, setIshowDelete] = useState(false);
  const handleDeleteForm = () => {
    setIshowDelete(false);
  };
  return (
    <Colxx xxs="12">
      {
        item.status !== 'Archived' && <Card className="d-flex flex-row mb-3">
          <div className="pl-2 d-flex flex-grow-1 min-width-zero">
            <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
              <p className="mb-1  text-small w-15 w-sm-100">
                <b>{item.option}</b>
              </p>
              <p className="mb-1 text-muted text-small w-15 w-sm-100">
                {item.status}
              </p>
              <p className="mb-1 text-muted text-small w-15 w-sm-70">
                {currency} {item.price}
              </p>
              <p className="mb-1 text-muted text-small w-15 w-sm-70">
                {item.discount}%
              </p>
              {/* <p className="mb-1 text-muted text-small w-15 w-sm-100">
              <button type="button" class="btn btn-link" onClick={() => { handleVoucherPaymentsById(item.id, false); }}>Purchased : {item.totalSell} </button>
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              <button type="button" class="btn btn-link" onClick={() => { handleVoucherPaymentsById(item.id, true); }}>Redeemed : {item.totalRedeem} </button>
            </p> */}
              <p className="mb-1 text-muted text-small w-15 w-sm-100">
                {currency}
                {item.discountedPrice}
              </p>
              <div className="w-15 w-sm-100">
                <UpdateVouchersForm
                  id={voucherId}
                  optionId={item.id}
                  propertyId={propertyId}
                  isBuyOption={isBuyOption}
                  voucherId={voucherId}
                  extractData={extractData}
                />
              </div>
              <div className="w-15 w-sm-100">
                <Button
                  color="danger"
                  size="xs"
                  onClick={() => setIshowDelete(true)}
                >
                  Delete
                </Button>
              </div>
            </div>
          </div>
        </Card>}
      {
        isshowDelete && <DeleteVoucherForm
          id={voucherId}
          optionId={item.id}
          propertyId={propertyId}
          isBuyOption={isBuyOption}
          voucherId={voucherId}
          extractData={extractData}
          handleDeleteForm={handleDeleteForm}
        />
      }
    </Colxx >
  );
}

export default React.memo(BuyOptionList);
